import React, { useEffect, useState, useContext, useRef } from "react";
import { Box, Button, Grid } from "@mui/material";
import MyCard from "../../../shared/components/MyCard";
import myFilter from "../../../shared/functions/myfilter";

const apiUrl = process.env.REACT_APP_API_URL;

function Products({ selectProduct, data, types }) {

  const [filter, setFilter] = useState('Kaikki Tuotteet');
  const [addmore, setAddmore] = useState(16);
  const loader = useRef(null);
  const [filteredData, setFilteredData]=useState([])

  const handleFilterChange = (newFilter) => {
    if (newFilter) {
      setFilter(newFilter);
      localStorage.setItem("filter", newFilter); // Filtreyi kaydet
    }
  };


  const moreproduct = () => {
    setAddmore((prevAddmore) => prevAddmore + 4);
    localStorage.setItem("addMore", addmore + 4); // Daha fazla ürün gösterme sayısını kaydet
  };

  useEffect(() => {
    const savedFilter = localStorage.getItem("filter");
    const savedAddMore = localStorage.getItem("addMore");

    if (savedFilter) {
      setFilter(savedFilter);
    } else if (types.length > 0) {
      setFilter('Kaikki Tuotteet');
    }

    if (savedAddMore) {
      setAddmore(parseInt(savedAddMore, 10));
    }
    
    setFilteredData ( myFilter(filter,data));
    selectProduct();
  }, [selectProduct, types,filter]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          moreproduct();
        }
      },
      { threshold: 1, rootMargin: "20%" }
    );

    if (loader.current) {
      observer.observe(loader.current);
    }

    return () => {
      if (loader.current) {
        observer.unobserve(loader.current);
      }
    };
  }, [loader]);

  

  return (
    <Box width='100%' display='flex' justifyContent='center' key='mainproducts' mt='1%'>
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      width={{ lg: "80%", md: "90%", sm: "96%" }}
    >
      {/* Filtre Butonları */}
      <Box
        sx={{
          mt: { md: "10vh", xs: "0px" },
          width: "100%",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap", // Responsive için
            justifyContent: "center",
            gap: "8px", // Butonlar arasındaki boşluk
            padding: "16px 0", // Üst ve alt boşluk
          }}
        >
          {["Kaikki Tuotteet", 'Nojatuolit',...types].map((type) => (
            <Button
              key={type}
              onClick={() => handleFilterChange(type)} // Tıklama ile filtre değiştir
              variant={filter === type ? "contained" : "outlined"} // Aktif filtreyi belirgin yap
              sx={{
                borderRadius: "16px",
                padding: "8px 16px",
                fontWeight: "bold",
                textTransform: "none",
                backgroundColor: filter === type ? "orange" : "white",
                color: filter === type ? "white" : "#757575",
                "&:hover": {
                  backgroundColor: filter === type ? "darkorange" : "#e0e0e0",
                },
              }}
            >
              {type}
            </Button>
          ))}
        </Box>
      </Box>

      {/* Ürün Kartları */}
      <Box width="100%">
        <Grid container spacing={1} alignItems="center" columns={{ sm: 12, md: 12, lg: 12 }} mt="6vh">
          {filteredData.slice(0, addmore).map((el) => (
            <Grid
              item
              xs={6}
              sm={6}
              md={4}
              lg={3}
              width="100%"
              container
              key={el.id}
              display="flex"
              justifyContent="center"
            >
              <MyCard el={el}   apiUrl={apiUrl} />
            </Grid>
          ))}
          <Grid
            item
            sm={12}
            md={12}
            lg={12}
            width="100%"
            justifyContent="center"
            display={filteredData.length > addmore ? "block" : "none"}
            ref={loader}
          >
            <Button
              color="error"
              variant="contained"
              width="40%"
              sx={{ ml: { xs: "35%", sm: "35%", md: "45%" } }}
              onClick={moreproduct}
            >
              Lisää Tuotteet
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
    </Box>
  );
}

export default Products;
